// 通用公用方法
 
import   {instance,instancep}   from './baseurl.js'
const $http = ({method='get', url, data,type}) => {
 
 
       
    
 
    return instance({
        method: method,
        url: url,
        headers: type?{'Content-Type': 'multipart/*'}:{'Content-Type': 'application/json'
        },

         
        data
    })    
};

// const $httpp = ({method='get', url, data,type}) => {
 
  
        
     
//         return instancep({
//             method: method,
//             url: url,
//             headers: type?{'Content-Type': 'multipart/*'}:{'Content-Type': 'application/json'
//             },
    
             
//             data
//         })    
//     };

export   {$http}